import React, { FC } from "react";
import { Link } from "react-router-dom";
import { Badge } from "antd";

/** interfaces */
import { Fulfillment } from "@secondcloset/types";
type OrderInterface = Fulfillment.Order;

const OrderID: FC<{
  text: string;
  status: OrderInterface["status"];
  id: OrderInterface["id"];
}> = ({ text, status, id }) => {
  const isCancelled = status === "cancelled";
  return (
    <Badge status={isCancelled ? "default" : undefined} offset={[10, 10]}>
      <Link to={`/fulfillment/orders/${id}`}>{text}</Link>
    </Badge>
  );
};

export default OrderID;
